import { atom } from "recoil";
import moment from "moment";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimeActualYearState = atom({
  key: "myTimeActualYearState",
  default: moment().format("YYYY"),
  effects_UNSTABLE: [ocPersistAtom],
});
